var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import PictureCollectionUpload from '@declaration/components/upload/PictureCollectionUpload.vue';
import { ClaimFileType } from '@shared/types/file';
const externalDamage = namespace('externalDamage');
let ExternalDamagePictures = class ExternalDamagePictures extends Vue {
    constructor() {
        super(...arguments);
        this.ClaimFileType = ClaimFileType;
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get externalDamage() {
        return this.change.data;
    }
    update(data) {
        this.updateDamage({ changeKey: this.changeKey, data });
    }
};
__decorate([
    externalDamage.Getter('change')
], ExternalDamagePictures.prototype, "changeGetter", void 0);
__decorate([
    externalDamage.Action('updateDamage')
], ExternalDamagePictures.prototype, "updateDamage", void 0);
ExternalDamagePictures = __decorate([
    Component({
        components: {
            PictureCollectionUpload,
        },
        props: {
            changeKey: { type: [String, Number], default: null },
        },
    })
], ExternalDamagePictures);
export default ExternalDamagePictures;
